<mat-card>
    <div class="container-fluid marginHeader" *ngIf="agreement; else noAgreement">

        <div class="row mt-3">
            <div class="col-md-3">
                <label class="form-text" for="agreementCode"><strong>Nº Acerto</strong></label>
                <span class="form-text" id="agreementCode">{{ agreement?.codigoAcerto || '' }}</span>
            </div>
            <div class="col-md-3">
                <label class="form-text" for="codigoEntidade"><strong>Entidade</strong></label>
                <span class="form-text" id="codigoEntidade">{{ agreement?.codigoEntidade || '' }}</span>
            </div>
            <div class="col-md-6">
                <label class="form-text" for="codigoEscola"><strong>Cobradora</strong></label>
                <span class="form-text" id="codigoEscola">{{ agreement?.companyName || '' }}</span>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-md-3">
                <label class="form-text" for="status"><strong>Status</strong></label>
                <span class="form-text" id="status">{{ agreement?.status || '' }}</span>
            </div>
            <div class="col-md-3">
                <label class="form-text" for="dataSolicitada"><strong>Data</strong></label>
                <span class="form-text" id="dataSolicitada">{{ agreement?.dataSolicitada | date: 'dd/MM/yyyy HH:mm'
                    }}</span>
            </div>
            <div class="col-md-3">
                <label class="form-text" for="valorTotal"><strong>Total</strong></label>
                <span class="form-text" id="valorTotal">{{ agreement?.valorTotal | currency:'BRL':'':'1.2-2' }}</span>
            </div>
        </div>

        <div class="row mt-10 align-items-center agreement-actions">
            <div class="col-md-3 col-12">
                <mat-form-field class="w-100 mb-0" [floatLabel]="'auto'" appearance="outline">
                    <mat-label>Mês contábil</mat-label>
                    <input matInput [matDatepicker]="basicDatepicker" [formControl]="date" />
                    <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #basicDatepicker startView="multi-year"
                        (monthSelected)="setMonthAndYear($event, basicDatepicker)">
                    </mat-datepicker>
                </mat-form-field>
            </div>

            <div class="col-auto">
                <button class="btn btn-primary ml-md-4 p-4" type="button" [disabled]="agreement?.statusId !== 2"
                    (click)="onStartAccountingProcess()" data-toggle="tooltip" data-placement="top"
                    title="Contabilizar">
                    <i class="fas fa-cog"></i>
                    Contabilizar
                </button>
            </div>

            <div class="col-auto">
                <button class="btn btn-secondary ml-md-4 p-4" [disabled]="true" type="button" data-toggle="tooltip"
                    data-placement="top" title="Imprimir">
                    <i class="fas fa-print"></i>
                    Imprimir
                </button>
            </div>

            <div class="col-auto">
                <button [disabled]="!(agreement?.statusId === 1)" class="btn btn-success ml-md-4 p-4" type="button"
                    data-toggle="tooltip" data-placement="top" title="Receber Acerto Avulso"
                    (click)="onReceiveSingleSettlement()">
                    <i class="fas fa-check"></i>
                    Receber Acerto Avulso
                </button>
            </div>
        </div>

        <hr />

        <div class="row">
            <div class="col d-flex justify-content-between align-items-center">
                <h5>Boletos</h5>
                <button class="btn btn-primary" [disabled]="!canModifyBoletos" (click)="onAddBoleto()">
                    <i class="fas fa-plus"></i> Adicionar Boleto
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <ng-container *ngIf="agreement?.boletos?.length; else noBoletos">
                    <div class="table-responsive">
                        <table class="table table-sm table-striped">
                            <thead>
                                <tr>
                                    <th>Carne</th>
                                    <th>Cód. Aluno</th>
                                    <th>Cód. Escola</th>
                                    <th>Vencimento</th>
                                    <th>Status</th>
                                    <th class="text-right">Nominal</th>
                                    <th class="text-right">Multa</th>
                                    <th class="text-right">Juros</th>
                                    <th class="text-right">Honorários</th>
                                    <th class="text-right">Correção</th>
                                    <th class="text-right">Pago</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let boleto of agreement?.boletos; let i = index">
                                    <td>{{ boleto?.numeroCarne }}</td>
                                    <td>{{ boleto?.codigoAluno }}</td>
                                    <td>{{ boleto?.codigoEscola }}</td>
                                    <td>{{ boleto?.dataVencimento | date: 'dd/MM/yyyy' }}</td>
                                    <td>{{ boleto?.statusCobrancaDescricao }}</td>
                                    <td class="text-right">{{ boleto?.valorNominal | currency:'BRL':'':'1.2-2' }}</td>
                                    <td class="text-right">{{ boleto?.multa | currency:'BRL':'':'1.2-2' }}</td>
                                    <td class="text-right">{{ boleto?.juros | currency:'BRL':'':'1.2-2' }}</td>
                                    <td class="text-right">{{ boleto?.honorarios | currency:'BRL':'':'1.2-2' }}</td>
                                    <td class="text-right">{{ boleto?.correcaoMonetaria | currency:'BRL':'':'1.2-2' }}</td>
                                    <td class="text-right">{{ boleto?.valorPago | currency:'BRL':'':'1.2-2' }}</td>
                                    <td class="action-cell">
                                        <button mat-icon-button color="warn" [disabled]="!canModifyBoletos" (click)="onRemoveBoleto(i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

    <ng-template #noBoletos>
        <mat-card>
            <p class="notData">Não existem Boletos a serem carregados!</p>
        </mat-card>
    </ng-template>

    <ng-template #noAgreement>
        <mat-card>
            <p class="notData">Detalhe do Acerto não encontrado!</p>
        </mat-card>
    </ng-template>

    <loader></loader>
</mat-card>